module.exports = __webpack_public_path__ + "img/invoice-de-male-mv.5e565494.png";